var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"show-timeout":200,"default-active":_vm.path,"mode":"vertical"},on:{"select":function (path) { return _vm.menuSelect(path); }}},_vm._l((_vm.routes),function(item){return _c('Item',{key:item.name,attrs:{"data":item}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b954872","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar/Menu/index.vue
// module id = null
// module chunks = 